export default __webpack_public_path__ + "c55fc81e0493ac7f3624e3ecf0b6305d.png";